export default __webpack_public_path__ + "static/improvement-calculator-dark-mode-bdcd67546ff48746dbe38adea3a60a6d.mp4";